/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { RadioType } from '../../enum/radio-type.enum';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class RadioAction extends SimpleAction<any> {
  public isOpen: boolean;
  public values: SimpleAction<any>[] = [];
  public currentValue: SimpleAction<any>;
  public radioType: RadioType;
  public keepSelectedValue = true

  public ngUnsubscribe: Subject<any> = new Subject();

  constructor(
    name: string,
    icon: string,
    dataSource: Observable<SimpleAction<any>[]>,
    text: string,
    type?: RadioType,
    currentValue?: SimpleAction<any>,
    align?: 'left' | 'center' | 'right',
  ) {
    super(name, icon, null, text);
    this.category = 'radio';
    if (align) {
      this.align = align;
    }
    this.currentValue = currentValue;
    this.icon = icon;
    if (this.currentValue && this.currentValue.icon) {
      this.icon = currentValue.icon;
      this.secondaryIcon = currentValue.secondaryIcon;
    }
    this.radioType = type ?? RadioType.CLASSIC;
    if (dataSource) {
      dataSource.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
        this.values = data;
      });
    }
  }

  override getActionType(): string {
    return 'radio';
  }

  switch(item: any) {
    this.currentValue = item;
  }

  getRowCount(): number {
    let count = 0;
    if (this.values) {
      count = this.values.length;
    }
    return count;
  }
}
